import { Link } from "react-router-dom";
import { CheckCircle2, ArrowRight } from "lucide-react";

export default function ThankYou() {
  return (
    <div data-testid="page-thank-you">
      <section className="relative py-32 overflow-hidden">
        <div className="absolute inset-0 eq-grid-bg" />
        <div className="eq-aurora" />
        <div className="relative max-w-3xl mx-auto px-6 md:px-10 text-center">
          <div className="w-16 h-16 mx-auto rounded-2xl bg-blue-500/10 border border-blue-500/40 grid place-items-center text-blue-300 shadow-[0_0_40px_rgba(37,99,235,0.4)]">
            <CheckCircle2 className="w-8 h-8" strokeWidth={1.6} />
          </div>
          <h1 className="mt-8 font-display text-5xl sm:text-6xl font-semibold tracking-tight">
            Thank you.
          </h1>
          <p className="mt-6 text-gray-400 text-lg leading-relaxed">
            Thank you for contacting Equinox Systems. We'll review your project
            details and follow up with next steps shortly.
          </p>
          <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
            <Link to="/" className="btn-primary" data-testid="thanks-home-btn">
              Back to Home <ArrowRight className="w-4 h-4" />
            </Link>
            <Link to="/packages" className="btn-ghost" data-testid="thanks-packages-btn">
              Browse Packages
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
